document.addEventListener('DOMContentLoaded', function () {
    // Attendre que les filtres soient bien présents dans le DOM
    const observer = new MutationObserver(() => {
      // Get checkbox state
      const checkbox = document.querySelector('input[type="checkbox"][value="1"][name*="filter.v.availability"]');
      // Get current URL
      const url = new URL(window.location.href);
      // Check if URL contains the availability filter param
      const hasAvailabilityFilter = url.search.includes("filter.v.availability");

      // If param is not present and checkbox is unchecked
      if (!hasAvailabilityFilter && !checkbox.checked) {
        // Get sort value
        const sort_by = document.querySelector('select[name="sort_by"]').value
        // Prepare new URL and set proper params
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.append("filter.v.availability", "1"); // "1" = En stock
        newUrl.searchParams.append("sort_by", sort_by)
        // Quick redirect to activate filters
        window.location.replace(newUrl.toString());
      }      
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });